// dependancys
import React, { useState, useEffect, useRef } from "reactn";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import FormGroup from "shared-anpost-components/components/form/form_group/FormGroup";
import InputGroup from "shared-anpost-components/components/form/input_group/InputGroup";
import Label from "shared-anpost-components/components/form/label/Label";
import Input from "shared-anpost-components/components/form/input/Input";
import Select from "shared-anpost-components/components/form/select/Select";
import AddressTemplate from "../addressLookUp/AddressTemplate";
import FieldError from "shared-anpost-components/components/form/fieldError/FieldError";
import FieldPrompt from "shared-anpost-components/components/form/fieldPrompt/FieldPrompt";
import Checkbox from "shared-anpost-components/components/form/checkbox/Checkbox";
import CheckboxLabel from "shared-anpost-components/components/form/checkbox/CheckboxLabel";
import InfoFlag from "../infoFlag/InfoFlag";
import Error from "../error/Error";
import MobilePhone from "../mobileGroup/mobilePhone";
import Notification from "shared-anpost-components/components/notification";
import BackButton from "shared-anpost-components/components/backButton";

import { FormTemplateStyled, FormTemplateWrapperStyled, FormHeading, FormBtnWrapper, FormTemplateBusiness } from "./FormTemplate.styled";

import appHook from "../../../hooks/appHook";

import validate from "./FormTemplate.validate";

const FormTemplate = ({ config, nextStep, sidePanelHeading, sidePanelInfo, error, heading }) => {
    const { handleKeyup, handleFocus, handleChange, handleBlur, handleChangeCheckbox, focus, values, errors, handleSubmit } = appHook(validate, nextStep, config);

    const [submitDisabled, setSubmitDisabled] = useState(true);
    const backBtn = useRef(null);

    const history = useHistory();

    const handleFormSubmit = e => {
        e.preventDefault();
        handleSubmit();
    };

    useEffect(() => {
        let disableBtn = false;
        // loop through all the fields
        config.fields.forEach(field => {
            // if any of them are required and the values doesn't exist, disable the button:
            if (field.required && !values[field.id] && field.formType !== "address") {
                disableBtn = true;
            }

            // handling for addresses
            if (field.formType === "address") {
                if (values[`${field.id}NatOrInternational`] !== "international") {
                    if (!values[`${field.id}Manual`]) {
                        if (!values[`${field.id}Valid`]) {
                            disableBtn = true;
                        }
                    }
                }
            }

            // do the same again if it's duo field (side by side)
            if (field.formType === "duoField") {
                field.fields.forEach(innerField => {
                    if (innerField.required && !values[innerField.id]) {
                        disableBtn = true;
                    }
                });
            }
        });
        setSubmitDisabled(disableBtn);
    }, [config, values]);

    const disableField = (id, disabledFlag) => {
        if (typeof values[`${id}Disabled`] === "boolean") {
            return values[`${id}Disabled`];
        }
        if (typeof disabledFlag === "boolean") {
            return disabledFlag;
        }
        return false;
    };

    useEffect(() => {
        if(backBtn) backBtn.current.focus();
    }, [])

    const getInput = val => {
        return (
            <FormGroup focused={focus === val.id ? true : !!(false || values[val.id])}>
                <InputGroup>
                    <Label htmlFor={val.id} text={values[val.displayTextOverride] || val.displayText} />
                    <Input
                        id={val.id}
                        type={val.type}
                        name={val.id}
                        change={handleChange}
                        keyup={handleKeyup}
                        focus={handleFocus}
                        blur={handleBlur}
                        value={values[val.id] || ""}
                        maxLength={val.maxLength}
                        disabled={disableField(val.id, val.disabled)}
                    />
                </InputGroup>
                {errors[val.id] && <FieldError error={errors[val.id]} />}
                {val.helperText && !errors[val.id] && <FieldPrompt message={val.helperText} />}
            </FormGroup>
        );
    };

    const getAddressOverview = val => {
        return (
                
                <div className="addressSummaryWrapper">{
                   val.data && val.data.length ? val.data.map((address, index) => {
                        return (
                            <div key={index} className="addressSummary">
                                <span className="summaryElement">{address}</span>
                            </div>
                        );
                   }) : ""
                }</div>
        );
    };

    const getCheckbox = val => {
        return (
            <FormGroup>
                <InputGroup error={errors[val.id]}>
                    {values[`${val.id}Disabled`] ? (
                        <InfoFlag text={val.disabledText} />
                    ) : (
                        <>
                            <Checkbox id={val.id} name={val.id} change={handleChangeCheckbox} value={values[val.id] || false} checked={values[val.id] ? true : null} required />
                            <CheckboxLabel checkbox="true" htmlFor={val.id} text={val.displayText} />
                        </>
                    )}
                </InputGroup>
                {errors[val.id] && <FieldError error={errors[val.id]} />}
            </FormGroup>
        );
    };

    const getSelect = val => {
        return (
            <FormGroup error={errors[val.id]}>
                <Select
                    labelText={val.displayText}
                    disabled={val.disabled || false}
                    showLabel
                    id={val.id}
                    name={val.id}
                    change={handleChange}
                    keyup={handleKeyup}
                    focus={handleFocus}
                    blur={handleBlur}
                    handler={val.handler}
                    defaultValue={val.displayText}
                    selectedValue={val.preselect || values[val.id] || ""}
                    options={values[val.optionsId] || val.options}
                    focused={focus === `${val.id}` ? true : !!(false || values[`${val.id}`])}
                />
                {errors[val.id] && <FieldError error={errors[val.id]} />}
            </FormGroup>
        );
    };

    const getAddressTemplate = val => {
        return (
            <AddressTemplate
                settings={val}
                showText={false}
                innerTitle={val.displayText}
                handleBlur={handleBlur}
                handleChange={handleChange}
                handleKeyup={handleKeyup}
                values={values}
                errors={errors}
                includeNickName={values.loggedIn}
            />
        );
    };

    const getMobilePhone = val => {
        return (
            <MobilePhone
                id={val.id}
                handleChange={handleChange}
                handleKeyup={handleKeyup}
                handleBlur={handleBlur}
                values={values}
                errors={errors}
                lockCountryCode={val.lockCountryToIE}
                innerTitle="Mobile Number"
            />
        );
    };

    const getErrorTemplate = val => {
        return <Error errorHeading={val.errorHeading} errorText={val.errorContent}></Error>;
    };

    return (
		<FormTemplateWrapperStyled>
			{config.backText && (
				<BackButton elementRef={backBtn} onClick={() => { history.push("/") }}>{config.backText}</BackButton>
			)}

			{config.heading && <h1>{config.heading}</h1>}
			{heading && <h1>{heading}</h1>}
			
			{config.description && <p>{config.description}</p>}
			<div className="flex--space-between">
				<FormTemplateStyled>
					{config.fields &&
						config.fields.map(val => {
							return (
								<>
								{ val.para && (
										<p>{val.para}</p>
									)}

									{ val.formHeading && (
										<FormHeading>
											<h6 className="mt3">{val.formHeading}</h6>
										</FormHeading>
									)}

									{val.formType === "address" && getAddressTemplate(val)}

									{val.formType === "noForm" && getAddressOverview(val)}

									{val.formType === "input" && getInput(val)}

									{val.formType === "checkbox" && getCheckbox(val)}

									{val.formType === "select" && getSelect(val)}

									{val.formType === "mobile" && getMobilePhone(val)}

									{val.formType === "duoField" && (
										<FormGroup classes="form__two-fields">
											{val.fields &&
												val.fields.map(innerField => {
													return <>{innerField.formType === "input" && getInput(innerField)}</>;
												})}
										</FormGroup>
									)}
									{val.formType === "error" && getErrorTemplate(val)}

									{val.notification &&
										<Notification
											colour={val.notification.colour}
											text={val.notification.text}
											additionalText={val.notification.additionalText}
                                            withMargin
										></Notification>
									}
								</>
							);
						})}
					{error && error.heading && error.content && <Error errorHeading={error.heading} errorText={error.content}></Error>}
					<FormBtnWrapper className="flex--space-between">
						{/* <button
							type="button"
							onClick={() => {
								history.push(config.cancelUrl ? config.cancelUrl : "/");
							}}
							className="gtm-cta bn bn--secondary"
						>
							Cancel
						</button> */}
						<button type="button" className={`gtm-cta bn bn--primary `} onClick={handleFormSubmit} disabled={submitDisabled}>
							Save
						</button>
					</FormBtnWrapper>
				</FormTemplateStyled>
				{sidePanelHeading && sidePanelInfo && (
					<FormTemplateBusiness>
						{sidePanelHeading && <h4>{sidePanelHeading}</h4>}

						{sidePanelInfo && <p>{sidePanelInfo}</p>}
					</FormTemplateBusiness>
				)}
			</div>
		</FormTemplateWrapperStyled>
    );
};
export default FormTemplate;

FormTemplate.propTypes = {
    config: PropTypes.object,
    nextStep: PropTypes.func,
    sidePanelHeading: PropTypes.string,
    sidePanelInfo: PropTypes.string,
    error: PropTypes.object,
	heading: PropTypes.string
};
